import { render, staticRenderFns } from "./LegalAcceptanceModal.vue?vue&type=template&id=cb3d5bc8&"
import script from "./LegalAcceptanceModal.vue?vue&type=script&lang=js&"
export * from "./LegalAcceptanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports